<template>
  <nav class="navbar">
    <router-link :to="{ name: 'Home' }">
      <img src="@/assets/images/logo.svg" />
    </router-link>
    <div>
      <h1 class="title">АИС РМЛ РАС</h1>
      <span class="location">Нижний Новгород</span>
    </div>

    <!-- Right navbar links -->
    <div class="mail ml-auto" v-if="$store.state.auth?.oidc?.user">
      <icon-component
        v-if="isSystemChatAvailable || isGeneralChatAvailable"
        class="mr-1"
        name="mail"
        @click="openMessenger"
      />
      <span
        v-if="isSystemChatAvailable || isGeneralChatAvailable"
        :class="{ 'text-bold': unreadMessageCount > 0 }"
        @click="openMessenger"
      >
        {{ unreadMessageCount }}
      </span>
    </div>

    <div class="user" v-if="$store.state.auth?.oidc?.user">
      <router-link :to="{ name: 'Profile' }">
        <span class="name">{{
          $store.state.auth.oidc.user.profile.family_name
        }}</span>
      </router-link>
      <span v-if="$store.state.auth.oidc.isExpired"> expired</span>
    </div>

    <div class="logout" v-if="$store.state.auth?.oidc?.user">
      <router-link to="/logout">
        <icon-component class="logout-icon" name="logout" />
      </router-link>
    </div>

    <div class="login ml-auto" v-else>
      <router-link to="/login">Войти</router-link>
    </div>
  </nav>
  <section v-if="modals.messenger.show" class="modals">
    <modal-component
      title="Мессенджер"
      class="modal-content--card"
      size-class="modal-xl modal-fullscreen-lg-less"
      @close="modals.messenger.show = false"
    >
      <MessengerForm :filter="modals.messenger.filter"></MessengerForm>
    </modal-component>
  </section>
</template>

<script>
import IconComponent from "@/common/ui/IconComponent";
import MessageApi from "@/modules/messenger/api/index";
import ModalComponent from "../ui/ModalComponent";
import MessengerForm from "@/modules/messenger/components/MessengerForm";
import Constants from "@/common/constants";
import security from "../mixins/security";

export default {
  name: "HeaderComponent",
  components: { MessengerForm, ModalComponent, IconComponent },
  mixins: [security],
  data() {
    return {
      isSystemChatAvailable: false,
      isGeneralChatAvailable: false,
      unreadMessageCount: 0,
      modals: {
        messenger: {
          show: false,
          filter: {
            dialogType: []/*[Constants.CuratorDialogType, Constants.SystemDialogType]*/,
          },
        },
      },
    };
  },
  created() {
    setTimeout(() => {
      const generalChatPromise = this.checkPermission(Constants.GeneralQuestionsChat).then((response) => {
        this.isGeneralChatAvailable = response.data;
        if(this.isGeneralChatAvailable)
          this.modals.messenger.filter.dialogType.push(Constants.CuratorDialogType);
      });
      const systemChatPromise = this.checkPermission(Constants.ViewSystemMessages).then((response) => {
        this.isSystemChatAvailable = response.data;
        if(this.isSystemChatAvailable)
          this.modals.messenger.filter.dialogType.push(Constants.SystemDialogType);
        if (this.isSystemChatAvailable) {
          MessageApi.getUnreadMessageCount(/*Constants.SystemDialogId*/).then(
            (response) => {
              this.unreadMessageCount = response.data;
            }
          );
        }
      });

      Promise.all([generalChatPromise, systemChatPromise])
        .then(() => {
          if (this.isSystemChatAvailable || this.isGeneralChatAvailable) {
            MessageApi.getUnreadMessageCount(/*Constants.SystemDialogId*/).then(
              (response) => {
                this.unreadMessageCount = response.data;
              }
            );
          }
        });

    }, 500);
  },
  methods: {
    openMessenger() {
      this.modals.messenger.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.navbar {
  display: flex;
  gap: 16px;
  align-items: center;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  border: none;
  padding-right: 20px;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 126%;
    /* or 30px */

    letter-spacing: 0.03em;
    text-transform: uppercase;
    margin: 0;
    justify-content: center;
  }

  .location {
    color: $gray-dark;
    cursor: pointer;
  }

  .mail {
    display: flex;
    gap: 8px;
    cursor: pointer;
  }

  .user {
    margin-right: 40px;
    font-weight: 500;
    cursor: pointer;
  }

  .mail,
  .name,
  .logout,
  .login {
    color: $black;

    &:hover {
      color: $blue;
    }
  }
  .mail span {
    margin-right: 20px;
  }
}
</style>
